import { cx } from '@/ui/classNames';

import styles from './Wordmark.module.css';

export function Wordmark({ className }: { readonly className?: string }) {
  return <span className={cx(styles.wordmark, className)}>OXELTE</span>;
}
